// import { DisplayadData } from "./displayad-data";
import { Component, OnInit } from '@angular/core';
import { RateserviceService } from '../services/rateservice.service';
import { AdRate } from '../adrate';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from '../Globals';

import { AdDataService } from '../services/addata.service';
import { HttpClient } from '@angular/common/http';
import { error } from 'util';

class displayadModelinf {
  adcategory: string;
  choosedAd: string;
  customradio: any;

  basicrate: any;
  widthinput: any;
  heightinput: any;
  adsizeinsqcm: any;
  uploadbtn: any;
  adsize: any;
  adcost: any;
  gst: any;
  totalCost: any;
  imagename: string;
  adtype: string;
  adpage: string;
  flagupload: any;
  flagdate: any;
  noofdays: any;
  email: any;
  addate: any;
  trxnid: any;
  fileData: File;
  uploadedFilePath: string;
  selectedDate: any;
  constructor() {
    this.adcategory = null;
    this.choosedAd = null;
    this.customradio = null;
    this.basicrate = null;
    this.widthinput = null;
    this.heightinput = null;
    this.adsizeinsqcm = null;
    this.uploadbtn = null;
    this.adsize = null;
    this.adcost = null;
    this.gst = null;
    this.totalCost = null;
    this.imagename = null;
    this.adtype = null;
    this.adpage = null;
    this.flagupload = null;
    this.flagdate = null;
    this.noofdays = null;
    this.email = null;
    this.addate = null;
    this.trxnid = null;
    this.fileData = null;
    this.uploadedFilePath = null;
    this.selectedDate = null;
  }

}

@Component({
  selector: 'app-classifieddisplay',
  templateUrl: './classifieddisplay.component.html',
  styleUrls: ['./classifieddisplay.component.css']
})
export class ClassifieddisplayComponent implements OnInit {
  displayadModel = {
    adcategory: null,
    choosedAd: null,
    customradio: null,
    basicrate: null,
    widthinput: null,
    heightinput: null,
    adsizeinsqcm: null,
    uploadbtn: null,
    adsize: null,
    adcost: null,
    adContent: null,
    adContentPreview: null,
    gst: null,
    totalCost: null,
    imagename: null,
    adtype: null,
    adpage: null,
    flagupload: null,
    flagdate: null,
    noofdays: null,
    email: null,
    addate: null,
    trxnid: null,
    fileData: null,
    uploadedFilePath: null,
    selectedDate: null,
    touched: null
  };
  adDetails = {
    adcategory:'ClassifiedDisplayAd',
    choosedAd: '',
    customradio: '',
    basicrate: '',
    widthinput: '',
    heightinput: '',
    adsizeinsqcm: '',
    uploadbtn: '',
    adContent: '',
    adContentPreview: '',
    adsize: '',
    adcost: '',
    gst: 0,
    totalCost: '',
    imagename: '',
    adtype: '',
    adpage: '2nd Page',
    noofdays: '',
    email: '',
    addate: '',
    trxnid: '',
    flagupload: true,
    flagdate: true,
    fileData: File = null,
    uploadedFilePath: '',
    selectedDate: [] = '',

    touched: ''
  };
  previewUrl: any = null;

  fileUploadProgress: string = null;




  id: number;
  adrate: AdRate = new AdRate();
  adCost: number;
  adSize: number;
  file: File;
  custom = 'one';
  buttonDisabled: boolean;
  filesize: number;
  heights = [
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    // '16',
    // '17',
    // '18',
    // '19',
    // '20',
    // '21',
    // '22',
    // '23',
    // '24',
    // '25',
    // '26',
    // '27',
    // '28',
    // '29',
    // '30',
    // '31',
    // '32',
    // '33',
    // '34',
    // '35',
    // '36',
    // '37',
    // '38',
    // '39',
    // '40',
    // '41',
    // '42',
    // '43',
    // '44',
    // '45',
    // '46',
    // '47',
    // '48',
    // '49',
    // '50',
    // "51",
    // "52"
  ];
  widths =
    [
      '4'
      /*  "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52" */
    ];
  rate: any;
  fileData: any;
  value: any;
  fileStatus: string;
  filestatus: string;
  constructor(private http: HttpClient,
              private rateService: RateserviceService,
              private router: Router,
              private route: ActivatedRoute,
              private rateservice: RateserviceService,
              private addata: AdDataService,
              public globals: Globals) { }

  ngOnInit() {

    this.basicrate();


    if (sessionStorage.getItem('Array')) {
      this.displayadModel = JSON.parse(sessionStorage.getItem('Array'));
      const obj = this.addata.getAdData();
      this.displayadModel = (obj) ? obj : this.adDetails;
      console.log(obj);
    } else {
      this.displayadModel = this.adDetails;
    }

    this.displayadModel.choosedAd = this.route.routeConfig.component.name;
    console.log(this.displayadModel.choosedAd);
  }
  fileProgress(fileInput: any) {
    {
      const ext = this.displayadModel.imagename.match(/\.([^\.]+)$/)[1];
      switch (ext) {
        case 'pdf':
        case 'eps':
        case 'tiff':
          this.fileStatus='*Saved Successfully';

          break;
        default:
          this.fileStatus='*File Format Not Supported';
          this.displayadModel.imagename = '';

      }
      this.displayadModel.flagdate = false;
      this.displayadModel.fileData =  fileInput.target.files[0] as File;
      sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));
      //  window.alert("FileData:" + this.displayadModel.fileData);
      // window.alert("FileData:" + this.displayadModel.fileData.name);
      this.preview();

    }

  }
  onSearchChange(): void {
    // this.globals.adcustom_size = searchValue;
    this.displayadModel.adsizeinsqcm =
      4 * this.displayadModel.heightinput;
    this.displayadModel.adsize =
      4 +
      'cm Wd. * ' +
      this.displayadModel.heightinput +
      'cm Lt.';
    this.displayadModel.adcost =
      (this.displayadModel.adsizeinsqcm * this.rate).toFixed(2);

    // console.log(this.rate);

    // this.globals.adSize = 4 * this.globals.adcustom_size;
    //  this.globals.adCost = this.globals.adSize * this.globals.adRate;
  }



  readFile(fileEvent: any) {
    const file = fileEvent.target.files;
    this.globals.fileSize = file.size;
    this.displayadModel.uploadbtn = file;
    /* if (file.size > 2048576)  // validation according to file size
    {
      document.getElementById("errorName5").innerHTML = "Image size too short";
      console.log('type', file.type);
    } */
  }
  // fileProgress(fileInput: any) {
  //   this.displayadModel.flagdate = false;
  //   this.displayadModel.fileData = <File>fileInput.target.files[0];
  //   sessionStorage.setItem("Array", JSON.stringify(this.displayadModel));
  //   // window.alert("FileData:" + this.displayadModel.fileData);
  //   // window.alert("FileData:" + this.displayadModel.fileData.name);
  //   this.preview();
  // }

  basicrate() {

    this.rateservice.getAdRate('classifieddisplayAd').subscribe(
      data => {
        //  this.adcost = data;
        //  console.log(this.adcost);
        const baserate = data[''];
        const resource = data[0];
        console.log(resource.adcost);
        this.rate = (resource.adcost);
        console.log(data);
      });
  }

  preview() {
    // Show preview
    const mimeType = this.displayadModel.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.displayadModel.fileData);
    reader.onload = _event => {
      this.previewUrl = reader.result;
    };
  }
  onFormSubmit() {
    this.displayadModel.imagename = this.displayadModel.fileData.name;
    // alert(this.displayadModel.imagename)
    console.log(this.displayadModel);

    sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));

    let obj = this.addata.getAdData();
    obj = this.displayadModel;
    this.addata.setAdData(obj);
  }



}
